import { IDictionary } from '~utilities/IDictionary';
import DisbursementTypeEnum from '~Api/Application/DisbursementTypeEnum';

const applicationDisbursementTypeLabels: IDictionary<string> = {
    [DisbursementTypeEnum.EstablishmentFee]: 'Establishment Fee',
    [DisbursementTypeEnum.LegalFees]: 'Legal Fees',
    [DisbursementTypeEnum.LendersOutlays]: 'Lenders Outlays',
    [DisbursementTypeEnum.OtherRetainedFunds]: 'Other Retained Funds',
    [DisbursementTypeEnum.PrepaidInterest]: 'Prepaid Interest',
    [DisbursementTypeEnum.RetainedContingency]: 'Retained Contingency',
    [DisbursementTypeEnum.RetainedFunds]: 'Retained Funds',
};

const extensionDisbursementTypeLabels: IDictionary<string> = {
    [DisbursementTypeEnum.EstablishmentFee]: 'Renewal Fee',
    [DisbursementTypeEnum.LegalFees]: 'Documentation Fee',
    [DisbursementTypeEnum.OtherRetainedFunds]: 'Other Retained Funds',
    [DisbursementTypeEnum.PrepaidInterest]: 'Prepaid Interest',
    [DisbursementTypeEnum.RetainedContingency]: 'Retained Contingency',
    [DisbursementTypeEnum.RetainedFunds]: 'Retained Funds',
};

export function getDisbursementTypeLabel(type: DisbursementTypeEnum, isExtension: boolean): string {
    if (isExtension) {
        return extensionDisbursementTypeLabels[type];
    }

    return applicationDisbursementTypeLabels[type];
}
